import styled from 'styled-components';
import { Checkbox as AntdCheckbox } from 'components/atoms/checkbox';

export const Container = styled.div`
  border-bottom: 1px solid var(--gray-20);
  margin-bottom: var(--spacing-05);
`;

export const Checkbox = styled(AntdCheckbox)`
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: var(--black-100);
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: var(--black-100);
    border: var(--black-100);
  }
`;
